import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Button} from '@betareader/design-system';

// pop-ups
import {toast} from 'react-toastify';

// i18n
import {withTranslation} from 'react-i18next';

// redux
import {push} from '../../../navigation';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import InviteManuscriptCollaboratorModal from './inviteManuscriptCollaboratorModal';
import {PaddedWrapper} from '../../../style';
import BetaIcon from 'src/components/BetaIcon';

export class ManuscriptCollaborators extends Component {
  constructor(props) {
    super(props);
    this.state = {
      manuscriptCollaborators: []
    };
  }

  componentDidMount() {
    this.fetchCollaborators();
  }

  fetchCollaborators = () => {
    const {idToken, currentBook} = this.props;
    fetch(
      `${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/books/${currentBook._id}/members`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'br-token': idToken
        }
      }
    )
      .then(res => res.json())
      .then(manuscriptCollaborators => {
        this.setState({
          manuscriptCollaborators
        });
      })
      .catch(() => {})
      .finally(() => {});
  };

  removeCollaborator = userId => {
    const {idToken, currentBook, t} = this.props;
    fetch(
      `${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/books/${currentBook._id}/members/${userId}`,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'br-token': idToken
        }
      }
    )
      .then(res => {
        if (res.status === 200) {
          // remove the collaborator from the ui as well
          this.setState(prevState => ({
            manuscriptCollaborators: [
              ...prevState.manuscriptCollaborators.filter(
                collaborator => collaborator.userId !== userId
              )
            ]
          }));
        } else {
          throw new Error(res.status);
        }
      })
      .catch(() => {
        toast.error(t('SomethingWentWrong'));
      })
      .finally(() => {});
  };

  render() {
    const {t} = this.props;
    const {manuscriptCollaborators = []} = this.state;

    return (
      <PaddedWrapper>
        <h1>{t('Collaborators')} <BetaIcon /></h1>
        <p>{t('InviteCollaboratorMsg')}</p>
        {manuscriptCollaborators.length > 0 && (
          <div style={{overflowX: 'auto'}}>
            <table className='plain-table'>
              <thead><tr><th scope='col'>{t('Name')}</th><th scope='col'>{t('Email')}</th><th scope='col'>{t('Actions')}</th></tr></thead>
              <tbody>
                {manuscriptCollaborators.map(collaborator => (
                  <tr key={collaborator._id || collaborator.userId}>
                    <td>{collaborator.displayName}</td>
                    <td>{collaborator.email}</td>
                    <td>
                      <Button variant='secondary'
                        aria-label={`${t('Remove')} ${collaborator.displayName}`}
                        onClick={() => this.removeCollaborator(collaborator.userId)}>
                        {t('Remove')}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <InviteManuscriptCollaboratorModal />
      </PaddedWrapper>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  currentBook: state.book.currentBook
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: newPage => push(newPage)
    },
    dispatch
  );

export default withTranslation()(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ManuscriptCollaborators)
  )
);
